import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import fields from './fields'
import orders from './orders'
import order from './order'
import images from './images'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    fields,
    orders,
    order,
    images
  }
})
